import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ExternalOutlined } from '@vindr/icons';

export interface FindingItem {
  name: string;
  prob: number; // Probability from 0 to 1
  // onClick?: () => void;
}

const MeasurementList = ({
  title,
  items,
  className,
  showProb = true,
  onClickItem = null,
}: {
  title: string;
  items: FindingItem[];
  className?: string;
  showProb?: boolean;
  onClickItem?: (item: FindingItem) => void;
}): JSX.Element => {
  const { t } = useTranslation('ViewerTool');

  return (
    <div
      className={classNames(className, 'overflow-hidden rounded-sm text-base')}
    >
      <div className="measurement-title bg-primary-500 px-3 py-1 text-lg font-bold shadow">
        {title}
      </div>
      <div className="measurement-list">
        {items.map((it) => (
          <div
            className="item flex justify-between bg-primary-400 px-3 py-2 text-base shadow"
            key={it?.name}
          >
            <span
              className={
                onClickItem ? 'cursor-pointer text-primary-light' : 'text-white'
              }
              onClick={onClickItem ? () => onClickItem(it) : null}
            >
              {t(it?.name)}
              {onClickItem && <ExternalOutlined className="ml-2" />}
            </span>
            {showProb && (
              <span className="text-primary-light">
                {(it?.prob * 100).toFixed()}%
              </span>
            )}
          </div>
        ))}
        {(!items || !items?.length) && (
          <div className="item bg-primary-400 px-3 py-2 shadow">-</div>
        )}
      </div>
    </div>
  );
};

export default MeasurementList;
